function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var YearOfPlentyOverlayTemplate = require('./year-of-plenty.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var YearOfPlentyOverlay = /*#__PURE__*/function () {
  function YearOfPlentyOverlay(app, mod) {
    _classCallCheck(this, YearOfPlentyOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.cardname = null;
    this.player = null;
    this.cardsToGain = [];
  }
  return _createClass(YearOfPlentyOverlay, [{
    key: "render",
    value: function render(card) {
      var _this = this;
      // Reset State!
      this.cardsToGain = [];
      this.overlay.show(YearOfPlentyOverlayTemplate(this.app, this.mod, this), function () {
        //Allow to cancel by clicking out of overlay
        _this.mod.game.state.players[_this.mod.game.player - 1].devcards.push(card);
        this_dev_card.mod.game.state.canPlayCard = true;
      });
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this_self = this;
      document.querySelectorAll('.settlers-select-options img').forEach(function (card) {
        card.onclick = function (e) {
          var target = e.currentTarget;
          var card = target.getAttribute('id');
          this_self.cardsToGain.push(card);
          if (this_self.cardsToGain.length == 2) {
            this_self.mod.addMove("year_of_plenty\t".concat(this_self.player, "\t").concat(this_self.cardname, "\t").concat(JSON.stringify(this_self.cardsToGain)));
            this_self.mod.endTurn();
            this_self.overlay.remove();
            return 0;
          } else {
            this_self.updateCards();
          }
        };
      });
      document.querySelectorAll('.settlers-selected-resources img').forEach(function (card) {
        card.onclick = function (e) {
          var target = e.currentTarget;
          var card = target.getAttribute('id');
          var index = this_self.cardsToGain.indexOf(this_self.cardsToGain[card]);
          if (index > -1) {
            // only splice array when item is found
            this_self.cardsToGain.splice(index, 1); // 2nd parameter means remove one item only
          }
          this_self.updateCards();
        };
      });
    }
  }, {
    key: "updateCards",
    value: function updateCards() {
      var html = "";
      for (var i = 0; i < this.cardsToGain.length; i++) {
        html += "<img id=\"".concat(i, "\" src=\"").concat(this.mod.returnCardImage(this.cardsToGain[i]), "\" >");
      }
      document.querySelector('.settlers-selected-resources').innerHTML = html;
      this.attachEvents();
    }
  }]);
}();
module.exports = YearOfPlentyOverlay;